import {clearWorkspaceMemory,invalidateWorkspaceMemory} from '../workspaceMemory';
import {parseTimestamp,localCalendarDay} from '../time';
const enrollmentMessages={"billing_update_pending":"Payment is processing. Refresh Billing before adding new agents.","agent_capacity_reached": "Your plan\u2019s agent limit has been reached. Retire an agent or contact your administrator.", "billing_grace_expired": "The 7-day payment grace period has ended. Resolve billing to add new agents.", "billing_subscription_required": "An active subscription is required to add new agents.", "billing_refresh_required": "Billing needs reconciliation before new agents can be added.", "paid_subscription_required": "A current paid subscription is required before applying enrollment limits."};
export const text = (value, fallback = '—') => typeof value === 'string' || typeof value === 'number' ? String(value) : fallback;
export const alertStatus = value => ['new', 'open'].includes(String(value || '').toLowerCase()) ? 'open' : String(value || 'unknown').toLowerCase();
export function normalizeAlert(item, scope, index) {
  const tenant = scope === 'workspace';
  const id = item.alert_id || item.id;
  return {
    id: id ? String(id) : null, key: scope + ':' + (id || index),
    isSyslog: tenant, scope, date: item.created_at || item.date || item.timestamp || '',
    threatType: text(item.threat_type || item.threatType, 'Security alert'),
    severity: text(item.severity, 'unknown').toLowerCase(),
    status: alertStatus(item.status), source: tenant ? text(item.source, 'syslog') : 'upload',
    sourceIp: text(item.source_ip || item.client_ip || item.ip, ''),
    sourceDevice: text(item.source_device || item.device_name, ''),
    collectorDevice: text(item.collector_device_name, ''),
    matchedRule: text(item.matched_rule), message: text(item.message || item.evidence || item.description, ''),
    threatScore: item.threat_score ?? null, country: text(item.country), asn: text(item.asn)
  };
}
export function selectAlerts(alerts, filters) {
  const query = filters.query.trim().toLowerCase();
  return alerts.filter(a =>
    (!filters.scope || a.scope === filters.scope) &&
    (!filters.status || a.status === filters.status) &&
    (!filters.severity || a.severity === filters.severity) &&
    (!filters.device || [a.sourceDevice,a.collectorDevice].includes(filters.device)) &&
    (!query || [a.threatType,a.sourceIp,a.sourceDevice,a.collectorDevice,a.matchedRule,a.message].join(' ').toLowerCase().includes(query)) &&
    ((!filters.start && !filters.end) || (localCalendarDay(a.date) && (!filters.start || localCalendarDay(a.date)>=filters.start) && (!filters.end || localCalendarDay(a.date)<=filters.end)))
  ).sort((a,b) => {
    if (filters.sort === 'priority') {
      const rank = {critical:4,high:3,medium:2,low:1};
      const diff = (rank[b.severity] || 0) - (rank[a.severity] || 0);
      if(diff) return diff;
    }
    return (parseTimestamp(b.date)?.getTime() || 0) - (parseTimestamp(a.date)?.getTime() || 0);
  });
}
export async function alertRequest(url, token, options = {}) {
  const controller = new AbortController();
  const external = options.signal;
  const abort = () => controller.abort();
  if(external?.aborted) controller.abort();
  external?.addEventListener('abort', abort, {once:true});
  const timer = setTimeout(abort, 15000);
  try {
    const response = await fetch(url, {...options, signal:controller.signal, cache:'no-store',
      headers:{Authorization:'Bearer ' + token, ...(options.headers || {})}});
    let data;
    try {data = await response.json();} catch {throw new Error('The server returned an unreadable response. Please retry.');}
    if(!response.ok) {
      if([401,403,422].includes(response.status)&&!external?.aborted)clearWorkspaceMemory();
      const error = new Error(enrollmentMessages[data?.error] || (response.status === 404 ? 'This alert is no longer available.' :
        response.status === 403 ? 'Your workspace access does not allow this request.' :
        response.status === 401 || response.status === 422 ? 'Your session has expired. Please sign in again.' :
        'The request could not be completed (' + response.status + ').')); 
      error.status = response.status; throw error;
    }
    const method=(options.method||'GET').toUpperCase();
    if(!['GET','HEAD'].includes(method)&&!(method==='POST'&&/\/cybedefender\/(Dashboard|reports)(?:\?|$)/.test(url)))invalidateWorkspaceMemory();
    return data;
  } catch(error) {
    if(error.name === 'AbortError' && !external?.aborted) throw new Error('The request timed out. Refresh its status before retrying.');
    throw error;
  } finally {clearTimeout(timer); external?.removeEventListener('abort', abort);}
}
